import { useLocation, useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from '../../components/ui';
import { images } from '../../config/colors';
import tocBackgroundFallback from '../../assets/tocBackground.jpg';
import styles from './ReceiveCoinsPage.module.css';

const tocBackground = images.background || tocBackgroundFallback;

interface LocationState {
  account?: {
    cid: string;
    qr_code: string;
  };
}

export function ReceiveCoinsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account } = (location.state as LocationState) || {};

  const qrValue = account?.qr_code || account?.cid;

  return (
    <div
      className={styles.background}
      style={{ backgroundImage: `url(${tocBackground})` }}
    >
      <div className={styles.container}>
        <p className={styles.prompt}>Show this code to the person giving you coins</p>
        <div className={styles.spacer} />
        <div className={styles.qrContainer}>
          {qrValue ? (
            <QRCodeSVG value={qrValue} size={200} />
          ) : (
            <p>Unable to generate QR code. Please go back and try again.</p>
          )}
        </div>
        <div className={styles.spacer} />
        <Button onClick={() => navigate(-1)}>
          Done
        </Button>
      </div>
    </div>
  );
}

export default ReceiveCoinsPage;
